module.exports = __webpack_public_path__ + "img/Artboard.012b23ba.svg";